import styled from "styled-components/macro";

export const Container = styled.div`
  margin: 0 auto;
  max-width: 900px;
`;

export const SubTitle = styled.h3`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 35px;
  text-align: left;
  margin-bottom: 36px;
`;

export const MainText = styled.p`
  font-size: 18px;
  margin-bottom: 18px;
`;

export const Divider = styled.span`
  height: 18px;
  display: block;
`;

export const Ul = styled.ul`
  margin-left: 25px;
  font-size: 18px;
  margin-bottom: 18px;
    li {
      margin-bottom: 5px;
    }
`;

export const LDash = styled.li`
  list-style: disc;
`
